var required = "requir'd";
var optional = "option'l";
var today = "T'day";
var Search = "Sail";
var Expand = "Elaborate";
var Year = "Year";
var Month = "Month";
var Help = "SOS";
var Success = "Victory";
var Warning = "A fell wind";
var Upload = "Board";
var Remove = "Scuttle";
var Cancel = "Abandon";
var On = "Ahoy";
var Off = "Avast";
var Clear = "Fall back";
var enPT = {
	required: required,
	optional: optional,
	today: today,
	"next-month": "Followin' month",
	"previous-month": "Precedin' month",
	"No results": "There be nothin' here fer ye",
	"No results for <q>{search}</q>": "There be nothin' here fer <q>{search}</q>",
	Search: Search,
	Expand: Expand,
	"Searching...": "Sailin' the seas...",
	"Searching for <q>{search}</q>": "Sailin' the seas fer <q>{search}</q>",
	"There was a problem completing your search": "Yer vessel has capsized along th' way",
	"Try again": "Sail again",
	"{count} selected": "{count} chos'n",
	Year: Year,
	Month: Month,
	"Start year": "Beginnin' year",
	"Start month": "Beginnin' month",
	"End year": "Endin' year",
	"End month": "Endin' month",
	"Select all": "Take 'em all",
	Help: Help,
	Success: Success,
	Warning: Warning,
	"Error": "Mayday",
	Upload: Upload,
	Remove: Remove,
	"Choose file": "Seek file",
	"Drag and drop here or <q>choose {maxFiles, plural, one {file} other {files}}</q>.": "Drag 'n' drop yer {maxFiles, plural, one {crate} other {crates}} here or <q>seek elsewhere</q>.",
	"No file chosen.": "Pick a crate, matey.",
	"{files, plural, one {1 file} other {# files}} chosen": "{files, plural, one {1 crate} other {# crates}} in th' hold",
	"Add up to {maxFiles, plural, one {1 file} other {# files}}.": "Add no more 'n {maxFiles, plural, one {a lone crate} other {# crates}}.",
	"Max file size: {size}.": "Room fer {size} in the hold.",
	"Accepts {list} file types.": "Accept'd cargo: {list}.",
	Cancel: Cancel,
	"Send message": "Send missive",
	On: On,
	Off: Off,
	Clear: Clear,
	"Select date": "Seek date"
};

export { Cancel, Clear, Expand, Help, Month, Off, On, Remove, Search, Success, Upload, Warning, Year, enPT as default, optional, required, today };
